import React, { useState } from 'react';
import { Info } from 'lucide-react';

interface TooltipProps {
  content: string;
  children?: React.ReactNode;
}

export const Tooltip: React.FC<TooltipProps> = ({ content, children }) => {
  const [show, setShow] = useState(false);

  return (
    <div className="relative inline-flex items-center gap-1">
      <span className="font-medium">{children}</span>
      <div
        onMouseEnter={() => setShow(true)}
        onMouseLeave={() => setShow(false)}
        className="cursor-help"
      >
        <button 
          type="button"
          className="ml-2 p-1 rounded-full text-white ring-1"
          style={{
            background: 'linear-gradient(to right, var(--color-primary), var(--color-secondary))',
            ringColor: 'var(--color-border)'
          }}
        >
          <Info className="w-4 h-4" />
        </button>
      </div>
      
      {show && (
        <div 
          className="absolute z-[60] left-0 bottom-full mb-2 p-2 text-sm rounded-lg shadow-xl whitespace-normal min-w-[200px] max-w-xs"
          style={{
            color: 'var(--color-text)',
            backgroundColor: 'var(--color-card-bg)',
            borderColor: 'var(--color-border)',
            borderWidth: '1px'
          }}
        >
          {content}
        </div>
      )}
    </div>
  );
};
